import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import FormField from '../layout/FormField';
import { Formik, Form as FormikForm, Field } from 'formik';
import * as Yup from 'yup';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls.js';
import CustomSelector from '../customSelector/CustomSelector';
import DataTable from 'react-data-table-component';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import { validateFileType } from '../../helpers/utils';
import moment from 'moment';
import _ from 'lodash';
import { toast } from 'react-toastify';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
const transitOptions = [
    { value: 'subway', label: 'Subway' },
    { value: 'train', label: 'Train' },
    { value: 'streetcar', label: 'Street Car' },
    { value: 'bus', label: 'Bus' }
];

const selectorStyles = {
    input: (provided, state) => ({
        ...provided,
        padding: '5px 0px',
        name: 'transit_type'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: '#ced4da'
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        marginLeft: 5
    }),
    menuList: (provided, state) => ({
        ...provided,
        fontSize: 14,
        color: '#a4a4a4'
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const EditAgencies = () => {
    const navigate = useNavigate();
    const validate = Yup.object({
        name: Yup.string().required('Required'),
        email: Yup.string().required('Required'),
        phone: Yup.string()
            .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4,5}$/, "Your phone number format must be '+1 233-343-2342'")
            .required('Required')
        // reward_listing: Yup.array().oneOf(rewardOptions).required('Required')
    });

    const [agencyDetails, setAgencyDetails] = useState();
    const [updateLogo, setUpdateLogo] = useState(false);
    const [agencyName, setAgencyName] = useState();
    const [noOfRoutes, setNoOfRoutes] = useState();
    const [noOfCommuters, setNoOfCommuters] = useState();
    const [phone, setPhone] = useState();
    const [transitType, setTransitType] = useState([]);
    const [isValidSelected, setIsValidSelected] = useState(false);

    const [selectedItem, setSelectedItem] = useState();
    const [allRewards, setAllRewards] = useState();
    const { state } = useLocation();
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDelModal, setShowDelModal] = useState(false);
    const [agencyLogo, setAgencyLogo] = useState(null);
    const [status, setStatus] = useState('');
    const [logoSelected, setLogoSelected] = useState(false);

    const { getToken } = useAuth();
    useEffect(() => {
        if (state?.agency_id) {
            getAgencyDetails(state?.agency_id);
            getAllRewards(pageSize, 1, '', '', state?.agency_id);
        }
    }, []);

    const setAgencyValues = (agency) => {
        if (agency) {
            setAgencyName(agency?.name);
            // setNoOfCommuters(agency?.noOfCommuters);
            // setNoOfRoutes(agency?.noOfRoutes);
            setPhone(agency?.phone_no);
            setStatus(agency?.status);
            setTransitType((s) => transitOptions.filter((item) => agency?.transit_mediums?.find((_item) => item.value == _item && item)));
        }
    };

    const getAgencyDetails = async (id = '') => {
        const token = getToken();
        if (id && token) {
            new WebApiCalls()
                .getSingleAgency(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        // setTransitType(res?.data?.transit_mediums?.join(", "))
                        setAgencyDetails(res?.data);
                        setAgencyValues(res?.data);
                        if (res.data.logo != '') setUpdateLogo(false);
                    }
                })
                .catch((err) => {
                    console.log('Error in Agency details:   ', err);
                });
        }
    };

    const getAllRewards = async (pageSize = 10, pageNo = 0, _status = '', _search = '', id) => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                //token, pageSize = 0, pageNo = 0, _status = '', _search = '', agencyId = ''
                .getAllRewards(token, pageSize, pageNo, _status, _search, id)
                .then((res) => {
                    // state?.agency_id;
                    if (res?.code === 200) {
                        setAllRewards(res?.data?.rewards);
                        setTotalRecords(res?.data?.totalCount);
                        // setAllRewards(() => res?.data?.rewards?.map((item) => ({ value: item._id, label: item.name })));
                        // let s = res?.data?.rewards.filter((item) => item.owner == state?.agency_id).length
                        //     ? res?.data?.rewards.filter((item) => item.owner == state?.agency_id)
                        //     : '';

                        // s = s.map((item) => {
                        //     return { value: item._id, label: item.name };
                        // });

                        // setSelectedReward(s ? s : '');
                    }
                })
                .catch((err) => {});
        }
    };

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    // const handleEditAgency = (val, action) => {
    const handleEditAgency = async (values) => {
        if (transitType?.length === 0) {
            toast.error('Please select atleast one transit type.');
            return;
        }
        const token = getToken();
        const webApi = new WebApiCalls();
        if (token && state?.agency_id && token) {
            const obj = {
                // noOfRoutes,
                // noOfCommuters,
                name: values.name,
                phone_no: values.phone,
                email: values.email,
                transit_mediums: transitType.map((item) => item.value),
                status: status
                // reward: selectedReward.map((item) => item.value)
            };
            if (updateLogo) {
                if (agencyLogo && isValidSelected) {
                    const data = new FormData();
                    data.append('image', agencyLogo);
                    const uploadedImage = await webApi.uploadImages(token, data);
                    obj.agency_logo = uploadedImage.data?.URL;
                } else {
                    if (!isValidSelected) {
                        toast.error('Please select a valid image format');
                        return;
                    }
                    toast.error('Please select a logo image');
                    return;
                }
            }

            webApi
                .updateAgency(token, obj, state?.agency_id)
                .then((res) => {
                    if (res.code === 200) {
                        toast.success('Agency is Updated Successfully.');
                        navigate('/agencies');
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };

    const searchDebounce = _.debounce((text) => {
        getAllRewards(undefined, undefined, '', text, state?.agency_id);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkRewards(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRewards(pageSize, 1, '', '', state?.agency_id);
                            setLoading(false);
                            toast.success('Rewards are Updated Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const updateSingle = async (selectedId, body) => {
        try {
            setLoading(true);
            const token = getToken();
            if (token)
                new WebApiCalls()
                    .updateReward(token, body, selectedId)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRewards(pageSize, 1, '', '', state?.agency_id);
                            setLoading(false);
                            toast.success('Reward is  updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        } else {
                            toast.error('Oops...! Something went wrong');
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const handleClose = () => {
        // setShowDetailModal(false);
        setShowDelModal(false);
        // setShowEditModal(false);
    };
    const handleDelete = async () => {
        const token = getToken();
        if (token && selectedItem?._id) {
            new WebApiCalls()
                .deleteReward(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Reward is deleted successfully.');
                        getAllRewards(pageSize, 1, '', '', state?.agency_id);
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };
    const handlePageChange = (pageNo) => {
        getAllRewards(pageSize, pageNo);
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllRewards(pageSize, pageNo, '', '', state?.agency_id);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);
    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkRewards(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRewards(pageSize, 1, '', '', state?.agency_id);
                            setLoading(false);
                            toast.success('Rewards are Delete Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };
    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Allowed Redeems</span>
                </h6>
            ),
            selector: (row) => row.noOfAllowRedeems,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Redeem Count</span>
                </h6>
            ),
            selector: (row) => row?.redeemedCount || 0,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Required Points</span>
                </h6>
            ),
            selector: (row) => row.requiredPoints,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Validity</span>
                </h6>
            ),
            selector: (row) => (row?.validity ? moment(row?.validity).format('MM-DD-YYYY') : ''),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    value={row?.status}
                    onChange={(e) => {
                        e.preventDefault();
                        updateSingle(row?._id, { status: e.target.value });
                    }}
                    className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        navigate('/reward-points/reward-point-details', {
                                            state: {
                                                reward_id: row._id,
                                                reward_details: row,
                                                redirect_url: '/agencies/edit-agency',
                                                agency_id: state?.agency_id,
                                                agency_details: state?.agency_details,
                                                type: 'agency'
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                    <div className="edit-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Edit reward</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={editIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/reward-points/edit-rewards-points', {
                                            state: {
                                                reward_id: row._id,
                                                redirect_url: '/agencies/edit-agency',
                                                agency_id: state?.agency_id,
                                                agency_details: state?.agency_details,
                                                type: 'agency'
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>

                    <div className="del-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete reward</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={delIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        setShowDelModal(true);
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            ),
            center: true
            // sortable: true
        }
    ];
    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
        // cells: {
        //     style: {
        //         paddingLeft: '8px', // override the cell padding for data cells
        //         paddingRight: '8px'
        //     }
        // }
    };

    return (
        <>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-5 rounded m-3">
                    <Formik
                        initialValues={{
                            name: agencyDetails?.name || '',
                            email: agencyDetails?.email || '',
                            phone: agencyDetails?.phone_no || ''
                            // phone_number: '',
                        }}
                        validationSchema={validate}
                        onSubmit={handleEditAgency}
                        enableReinitialize={true}
                    >
                        {(formik) => (
                            <FormikForm
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label className="mb-0">Agency Logo</Form.Label>
                                            <Form.Control
                                                className="form-control common-input"
                                                type="file"
                                                onChange={(e) => {
                                                    const { name } = e.target.files[0];
                                                    if (validateFileType(name)) {
                                                        setAgencyLogo(e.target.files[0]);
                                                        setIsValidSelected(true);
                                                        setUpdateLogo(true);
                                                        return;
                                                    }
                                                    setIsValidSelected(false);
                                                    toast.error('File format is not supported!');
                                                }}
                                            />
                                            {/* <Form.Text className="text-danger">
                        Required
                    </Form.Text> */}
                                        </Form.Group>
                                        <img src={agencyLogo} alt="" />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <FormField
                                            className="form-control common-input"
                                            label="Name"
                                            name="name"
                                            type="text"
                                            placeholder="Enter name"
                                            onChange={formik.handleChange}
                                            value={formik.values.name}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <FormField
                                            className="form-control common-input"
                                            label="Email"
                                            name="email"
                                            type="text"
                                            placeholder="Enter name"
                                            onChange={formik.handleChange}
                                            value={formik.values.email}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <FormField
                                            className="form-control common-input"
                                            label="Phone Number"
                                            name="phone"
                                            type="text"
                                            placeholder="Enter phone"
                                            onChange={formik.handleChange}
                                            value={formik.values.phone}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-4 mb-md-2">
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        {/* <div className='form-label mb-0'>Transit Type</div> */}
                                        <Form.Group>
                                            <Form.Label className="form-label mb-2">Transit Type</Form.Label>
                                            <Select
                                                options={transitOptions}
                                                isMulti
                                                customStyles={selectorStyles}
                                                value={transitType}
                                                onChange={(e) => setTransitType(e)}
                                            />
                                            {/* <Form.Text className="text-danger">
                        Required
                    </Form.Text> */}
                                        </Form.Group>
                                        {/* <Field name="transit_type" onChange={val => {
                    const s = val.map(item => item.value).join(',')
                    // formik.setFieldValue("transit_type", s)

                }
                } component={CustomSelector} options={transitOptions} /> */}
                                        {/* <Select isMulti options={transitOptions}
                    value={selectedOption}
                    // value={defaultValue(options, formik.values.transit_type)} 
                    customStyles={selectorStyles}
                    onChange={(e) => {
                        console.log("e here:    ", e)
                        // formik.setFieldValue("transit_type", e.value)
                        // formik.handleChange(e)
                    }} /> */}
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <select className="common-selector" value={status} onChange={(e) => setStatus(e.target.value)}>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div className="text-end">
                                    <Link to="/agencies">
                                        <Button type="submit" className="theme-cancel-btn me-3">
                                            Cancel
                                        </Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Update
                                    </Button>
                                </div>
                            </FormikForm>
                        )}
                    </Formik>

                    <hr />
                    <Row className="mt-4">
                        <Col md={4}>
                            <div className="detail-value">Rewards Listing</div>
                        </Col>
                    </Row>
                    <div>
                        <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                            <Modal.Title className="text-center">
                                <h6 className="text-capitalize mt-2">
                                    <span className=" breadcrumb-heading">Change Status</span>
                                </h6>
                                {/* Routes */}
                                <hr></hr>
                            </Modal.Title>
                            <Modal.Body className="text-center">
                                {/* <div className="icon-warning-wrapper my-1 mt-1"><img src={warningIcon} alt="" /></div> */}
                                <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                                <div className="text-content-wrapper mt-3">
                                    <div>
                                        <Button
                                            className="add-record-btn  justify-content-center w-140"
                                            style={{ background: '#198754' }}
                                            onClick={() => {
                                                setChangeStatusModal(false);
                                                updateBulk('active');
                                            }}
                                        >
                                            Active
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            className="add-record-btn  justify-content-center w-140"
                                            style={{ background: '#F32013' }}
                                            onClick={() => {
                                                setChangeStatusModal(false);
                                                updateBulk('inactive');
                                            }}
                                        >
                                            Inactive
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer className="border-0 mt-2"></Modal.Footer>
                        </Modal>
                        <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Reward?'} />
                        <Row className="mb-4 mt-1">
                            <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                                <input
                                    type={'search'}
                                    className="search-input-bar"
                                    placeholder={'Search here...'}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        searchDebounce(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                                <div className="d-flex gap-10 justify-content-start">
                                    <h6 className="text-capitalize mt-2 text-center">
                                        {/* <span className="fw-bold" style={{ whiteSpace: 'nowrap' }}>
                            Filter By
                        </span> */}
                                    </h6>
                                    {/* <select
                        onChange={(e) => {
                            getAllVendors(undefined, undefined, e.target.value);
                            setIsTypeFilterSelected(e.target.value ? true : false);
                        }}
                        className="status-selector w-120"
                        aria-label="Default select example"
                        style={{ color: !isTypeFilterSelected ? '#9a9a9a' : '' }}
                    >
                        <option value={''}>Transit Type</option>
                        <option value={'bus'}>Bus</option>
                        <option value={'streetcar'}>Street Car</option>
                        <option value={'subway'}>Subway</option>
                        <option value={'train'}>Train</option>
                    </select> */}
                                    <select
                                        onChange={(e) => {
                                            getAllRewards(undefined, undefined, e.target.value, '', state?.agency_id);
                                            setIsFilterSelected(e.target.value ? true : false);
                                        }}
                                        className="status-selector w-120"
                                        aria-label="Default select example"
                                        style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                                    >
                                        <option value="">Status</option>
                                        <option value={'active'}>Active</option>
                                        <option value={'inactive'}>Inactive</option>
                                    </select>
                                </div>
                            </Col>
                            <Col sm={5} md={5}>
                                <div className="d-flex gap-10 justify-content-end h-100">
                                    {!buttonDisable && (
                                        <>
                                            <Button
                                                className="add-record-btn justify-content-center w-140"
                                                style={{ background: '#F3D119', color: 'black' }}
                                                onClick={(e) => {
                                                    // updateBulk('active');
                                                    setChangeStatusModal(true);
                                                    // setActionType('add');
                                                    // setShowAddEditModal(true);
                                                }}
                                                disabled={buttonDisable}
                                            >
                                                Change Status
                                                {/* {activeButton} */}
                                            </Button>
                                            <Button
                                                className="add-record-btn  justify-content-center w-140"
                                                style={{ background: 'red' }}
                                                onClick={(e) => {
                                                    deleteBulk();
                                                    // setActionType('add');
                                                    // setShowAddEditModal(true);
                                                }}
                                                disabled={buttonDisable}
                                            >
                                                Delete
                                            </Button>
                                        </>
                                    )}
                                    <Button
                                        className="add-record-btn justify-content-center  w-140"
                                        style={{ background: '#13aa61' }}
                                        onClick={(e) => {
                                            navigate('/reward-points/add-rewards-points', {
                                                state: {
                                                    redirect_url: '/agencies/edit-agency',
                                                    agency_id: state?.agency_id,
                                                    type: agencyDetails?.type
                                                }
                                            });
                                            //add-rewards-pointsadd-rewards-points
                                            // setActionType('add');
                                            // setShowAddEditModal(true);
                                        }}
                                    >
                                        Add
                                    </Button>
                                </div>
                                {/* </Col> */}
                            </Col>
                        </Row>

                        <DataTable
                            columns={columns}
                            data={allRewards}
                            selectableRows
                            pagination
                            paginationServer
                            paginationTotalRows={totalRecords}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            progressPending={allRewards && allRewards?.length >= 0 ? false : true}
                            responsive
                            direction="auto"
                            fixedHeaderScrollHeight="300px"
                            subHeaderAlign="right"
                            subHeaderWrap
                            customStyles={customStyles}
                            onSelectedRowsChange={handleRowSelected}
                            clearSelectedRows={toggleCleared}
                            // defaultSortFieldId={1}
                        />
                    </div>
                </Col>
            </Row>
        </>
    );
};
export default EditAgencies;
